import { ECSLContainerStatus } from "src/types/global_enums";

const ALL_CONTAINER_STATUSES = [
    ECSLContainerStatus.AVAILABLE,
    ECSLContainerStatus.OPEN,
    ECSLContainerStatus.EMPTY,
    ECSLContainerStatus.FINISHED,
];
export class ContainerStatusFlow {
    private currentStatus: ECSLContainerStatus;

    constructor(status: ECSLContainerStatus) {
        this.currentStatus = status;
    }

    public getAvailableTransitions(): ECSLContainerStatus[] {
        switch (this.currentStatus) {
            case ECSLContainerStatus.AVAILABLE:
            case ECSLContainerStatus.OPEN:
            case ECSLContainerStatus.EMPTY:
            case ECSLContainerStatus.FINISHED:
                // For now, allow all transitions from all states
                return ALL_CONTAINER_STATUSES;
            default:
                return [];
        }
    }

    public requiresSignatureForTransition(newStatus: ECSLContainerStatus): boolean {
        return newStatus === ECSLContainerStatus.FINISHED;
    }

    public canTransitionTo(newStatus: ECSLContainerStatus): boolean {
        return this.getAvailableTransitions().includes(newStatus);
    }

    public transition(newStatus: ECSLContainerStatus): ECSLContainerStatus | null {
        if (!this.canTransitionTo(newStatus)) {
            return null;
        }
        return newStatus;
    }
}
